import { render } from "./CampaignCard.vue?vue&type=template&id=c817a686&scoped=true"
import script from "./CampaignCard.vue?vue&type=script&lang=js"
export * from "./CampaignCard.vue?vue&type=script&lang=js"

import "./CampaignCard.vue?vue&type=style&index=0&id=c817a686&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c817a686"]])

export default __exports__